<template>
  <button @click.prevent="handleClick" class="progress-button" :data-in-progress="inProgress">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "ProgressButton",
  props: ["inProgress"],
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
}
</script>

<style lang="scss" scoped>
  $border-width: 2px;
  $width: 70px + $border-width;
  $padding: 15px;
  $spinner-border-width: 6px;
  $spinner-gap: 12px;
  $spinner-width: $width + $spinner-gap;

  .progress-button {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    height: $width;
    width: $width;
    padding: $padding;
    margin: 0;
    text-align: center;
    border-radius: $width;
    border: solid 2px fade-out($color: $color-white, $amount: 1);
    cursor: pointer;
    background-color: $color-white;
    color: $color-black;
    transition: none;

    &[data-in-progress=true], &:hover, &:focus, &:active {
      outline: none;
      border-color: $color-white;
      color: $color-white;
      background-color: $color-blue;

      &::v-deep svg, * {
        color: $color-white;
        fill: $color-white;
      }
    }

    &[data-in-progress=true] {
      &:before {
        content: " ";
        position: absolute;
        top: -$spinner-gap - $border-width;
        left: -$spinner-gap - $border-width;
        height: $spinner-width;
        width: $spinner-width;
        border: solid $spinner-border-width $color-blue;
        border-color: $color-blue transparent $color-blue transparent;
        border-radius: 50%;
        animation: loading-spinner 1.2s ease-in infinite;
      }
    }

    &::v-deep svg, * {
      width: 100%;
      max-height: 100%;
      color: $color-black;
      fill: $color-black;
      transition: none;
    }

  }

@keyframes loading-spinner {
  0% {
    transform: rotate(0deg);
    border-color: $color-blue transparent $color-blue transparent;
  }
  50% {
    border-color: $color-grey-dark transparent $color-grey-dark transparent;
  }
  100% {
    transform: rotate(360deg);
    border-color: $color-blue transparent $color-blue transparent;
  }
}
</style>
